export type SCode = { label: string; value: string } | null;

export const getSCode = (
  codes: SCode[],
  value: string | number
): SCode | undefined => {
  if (typeof value === "number") {
    return codes.filter((v) => v?.value === value.toString()).shift();
  }
  return codes.filter((v) => v?.value === value).shift();
};

export const sample: SCode[] = [
  { label: "A", value: "0" },
  { label: "B", value: "1" },
  { label: "C", value: "2" },
];

// 消化区分(B000関連)
export const B000ShokaKbn: SCode[] = [
  { label: "標準", value: "0" },
  { label: "消化", value: "1" },
];

// 消化区分
export const ShokaKbn: SCode[] = [
  { label: "全件", value: "0" },
  { label: "通常", value: "1" },
  { label: "消化", value: "2" },
];

// 消化区分(B020030)
export const B020030ShokaKbn: SCode[] = [
  { label: "通常", value: "0" },
  { label: "消化", value: "1" },
  { label: "全件", value: "2" },
];

// 取引先分類
export const Torihikisakibun: SCode[] = [
  { label: "得意先分類1", value: "11" },
  { label: "得意先分類2", value: "12" },
  { label: "得意先分類3", value: "13" },
  { label: "得意先分類4", value: "14" },
  { label: "得意先分類5", value: "15" },
];

// 受注ステータス(検索用)
export const JuchuStatus: SCode[] = [
  { label: "全件", value: "1" },
  { label: "未確定", value: "2" },
  { label: "受注確定済", value: "3" },
  { label: "キャンセル", value: "4" },
];

// テーブル表示用ステータス
export const B010020JuchuStatus: SCode[] = [
  { label: "未確定", value: "0" },
  { label: "確定済", value: "1" },
  { label: "出荷予定作成済", value: "2" },
  { label: "出荷確定済", value: "3" },
  { label: "キャンセル", value: "9" },
];

// B010020 受注照会の出力順
export const B010020SyuturyokuKbn: SCode[] = [
  { label: "受注日", value: "0" },
  { label: "発送日", value: "1" },
  { label: "得意先", value: "2" },
  { label: "受注No", value: "3" },
];

// B010040 受注チェックリストの出力順
export const B010040Sort: SCode[] = [
  { label: "受注日", value: "0" },
  { label: "受注No", value: "1" },
  { label: "得意先", value: "2" },
  { label: "受注担当者", value: "3" },
];

// B000202 商品分類照会の商品分類
export const Shohinbun: SCode[] = [
  { label: "大分類", value: "0" },
  { label: "中分類", value: "1" },
  { label: "小分類", value: "2" },
];

// B010030 受注明細照会の出力順
export const B010030Shutsuryokujun: SCode[] = [
  { label: "受注日", value: "0" },
  { label: "発送日", value: "1" },
  { label: "商品", value: "2" },
  { label: "得意先", value: "3" },
  { label: "受注No.", value: "4" },
];

// B060020 トータル加工用リストの発行区分
export const B060020HakkoKbn: SCode[] = [
  { label: "未発行", value: "0" },
  { label: "全件", value: "1" },
];

// B060030 受注生産品店別組立出荷リストの発行区分
export const B060030HakkoKbn: SCode[] = [
  { label: "未発行", value: "0" },
  { label: "全件", value: "1" },
];

// 発送区分コード
export const HasokbnCd: SCode[] = [
  { label: "通常便", value: "0" },
  { label: "指定便", value: "1" },
  { label: "緊急出荷（クレーム）", value: "2" },
];

// 発送先コード
export const HasosakiCd: SCode[] = [
  { label: "直送", value: "0" },
  { label: "本社入れ", value: "1" },
  { label: "大阪入れ", value: "2" },
  { label: "札幌入れ", value: "3" },
  { label: "福岡入れ", value: "4" },
  { label: "名古屋入れ", value: "5" },
];

// 商品種別
export const ShohinshubetsuKbn: SCode[] = [
  { label: "通常商品", value: "1" },
  { label: "見込生産品", value: "3" },
  { label: "受注生産品", value: "4" },
  { label: "カレンダー", value: "5" },
  { label: "クリスマスカード", value: "6" },
  { label: "クリスマス雑貨", value: "7" },
  { label: "限定品", value: "8" },
  { label: "材料品", value: "9" },
];

// PP 掛け区分
export const PpgakeKbn: SCode[] = [
  { label: "無", value: "0" },
  { label: "有", value: "1" },
];

// 値付け区分
export const NetsukeKbn: SCode[] = [
  { label: "無", value: "0" },
  { label: "有", value: "1" },
];

// B060010 製造チェック照会の発行区分(DB: 製造指示ファイル.製造チェックリスト発行済区分)
export const ListhakkozumiKbn: SCode[] = [
  { label: "未発行", value: "0" },
  { label: "全件", value: "1" },
];

// B060010 製造チェック照会の生産区分
export const SeisanKbn: SCode[] = [
  { label: "受注生産", value: "0" },
  { label: "見込生産", value: "1" },
];

// B060010 製造チェック照会の完了区分
export const KanryoKbn: SCode[] = [
  { label: "全件", value: "0" },
  { label: "未完了", value: "1" },
  { label: "完了", value: "2" },
];

// B060010 製造チェック照会の出力順
export const B060010Shutsuryokujun: SCode[] = [
  { label: "受注日", value: "0" },
  { label: "製作日", value: "1" },
  { label: "得意先", value: "2" },
];

// B080060 出荷確定の出荷状況
export const Shukajokyo: SCode[] = [
  { label: "未処理", value: "0" },
  { label: "指示済", value: "1" },
  { label: "確定済", value: "2" },
];

// B090010 在庫照会(本社業務)の倉庫種別
export const Sokoshubetsu: SCode[] = [
  { label: "論理倉庫", value: "1" },
  { label: "引当倉庫", value: "2" },
  { label: "材料倉庫", value: "3" },
  { label: "返品倉庫", value: "4" },
  { label: "その他倉庫", value: "5" },
];

// B090010 在庫照会(本社業務)の出力順
export const B090010Shutsuryokujun: SCode[] = [
  { label: "商品コード", value: "0" },
  { label: "倉庫ｺｰﾄﾞ", value: "1" },
  { label: "カナ名", value: "2" },
];

// B090011 在庫照会(物流業務)の出力順
export const B090011Shutsuryokujun: SCode[] = [
  { label: "商品コード", value: "0" },
  { label: "倉庫ｺｰﾄﾞ", value: "1" },
  { label: "カナ名", value: "2" },
];

// B000170 仕入先照会 仕入先分類コード
export const Shiiresakibun: SCode[] = [
  { label: "仕入先分類コード1", value: "1" },
  { label: "仕入先分類コード2", value: "2" },
  { label: "仕入先分類コード3", value: "3" },
  { label: "仕入先分類コード4", value: "4" },
  { label: "仕入先分類コード5", value: "5" },
];

// 受注区分
export const JuchuKbn: SCode[] = [
  { label: "通常受注", value: "0" },
  { label: "見込品生産", value: "1" },
];

// 消費税区分
export const ZeiKbn: SCode[] = [
  { label: "外税/明細単位", value: "0" },
  { label: "外税/伝票単位", value: "1" },
  { label: "外税/請求単位", value: "2" },
  { label: "内税/明細単位", value: "3" },
  { label: "非課税", value: "4" },
];

// 帳端区分
export const ChohaKbn: SCode[] = [
  { label: "今回締め", value: "0" },
  { label: "次回締め", value: "1" },
  { label: "次々回締め", value: "2" },
];

// 商品種別区分(受注確定条件)
export const ShohinshubetsuKbnJuchuKakutei: SCode[] = [
  { label: "すべて", value: "0" },
  { label: "受注生産品を含む", value: "1" },
  { label: "受注生産品を含まない", value: "2" },
];

// 受注内訳区分
export const JuchuUchiwakeKbn: SCode[] = [
  { label: "通常", value: "0" },
  { label: "特売", value: "1" },
  { label: "値引", value: "2" },
  { label: "見本", value: "3" },
  { label: "諸経費", value: "4" },
  { label: "送料", value: "5" },
];

// 予約区分
export const YoyakuKbn: SCode[] = [
  { label: "無", value: "0" },
  { label: "有", value: "1" },
];

// 諸口区分
export const ShokuchiKbn: SCode[] = [
  { label: "標準", value: "0" },
  { label: "諸口", value: "1" },
];

// B000220 在庫照会の出力順
export const B000220Shutsuryokujun: SCode[] = [
  { label: "商品コード", value: "0" },
  { label: "倉庫コード", value: "1" },
  { label: "カナ名", value: "2" },
];

// 採番種別
export const Saibanshubetsu: SCode[] = [
  { label: "APJJAN", value: "0" },
  { label: "APJ工房JAN", value: "1" },
  { label: "インストア", value: "2" },
];

// B000160 発注番号照会の完了区分
export const B000160KanryoKbn: SCode[] = [
  { label: "未完了", value: "0" },
  { label: "全件", value: "1" },
];

// B000160 発注番号照会の出力順
export const B000160Shutsuryokujun: SCode[] = [
  { label: "発注日", value: "0" },
  { label: "入荷予定日", value: "1" },
  { label: "商品", value: "2" },
  { label: "仕入先", value: "3" },
  { label: "倉庫", value: "4" },
  { label: "発注No.", value: "5" },
];

// B000160 発注番号照会の商品種別
export const B000160ShohinshubetsuKbn: SCode[] = [
  { label: "全件", value: "0" },
  { label: "通常商品", value: "1" },
  { label: "見込み生産", value: "3" },
  { label: "受注生産", value: "4" },
  { label: "カレンダー", value: "5" },
  { label: "クリスマスカード", value: "6" },
  { label: "クリスマス雑貨", value: "7" },
  { label: "限定品", value: "8" },
  { label: "材料品", value: "9" },
];

//B020050 売上チェックリストの消化区分
export const B020050ShokaKbn: SCode[] = [
  { label: "全件", value: "0" },
  { label: "通常", value: "1" },
  { label: "消化", value: "2" },
];

//B020050 売上チェックリストの出力順
export const B020050Sort: SCode[] = [
  { label: "得意先", value: "0" },
  { label: "売上担当者", value: "1" },
  { label: "売上日", value: "2" },
  { label: "売上No", value: "3" },
];

//B020030 売上明細照会の出力順
export const B020030Shutsuryokujun: SCode[] = [
  { label: "売上日", value: "0" },
  { label: "商品", value: "1" },
  { label: "得意先", value: "2" },
  { label: "売上No", value: "3" },
];

// B090040 在庫調整入力の調整区分
export const B090040ChoseiKbn: SCode[] = [
  { label: "+調整", value: "0" },
  { label: "-調整", value: "1" },
];

// 伝票発行区分
export const DenpyoHakoKbn: SCode[] = [
  { label: "非発行", value: "0" },
  { label: "発行する", value: "1" },
];

// 請求書発行区分
export const SeikyusyoHakoKbn: SCode[] = [
  { label: "なし", value: "0" },
  { label: "あり", value: "1" },
];

// 売上内訳区分
export const UriageUchiwakeKbn: SCode[] = [
  { label: "通常", value: "0" },
  { label: "特売", value: "1" },
  { label: "値引", value: "2" },
  { label: "送料", value: "5" },
  { label: "通常返", value: "10" },
];

// B090050 受払区分
export const B090050UkeharaiKbn: SCode[] = [
  { label: "受注(商品引当)", value: "01" },
  { label: "受注(材料引当)", value: "02" },
  { label: "受注(商品引当取消)", value: "03" },
  { label: "受注(材料引当取消)", value: "04" },
  { label: "出荷", value: "11" },
  { label: "出荷(商品引当完了)", value: "12" },
  { label: "入荷", value: "21" },
  { label: "入荷(材料引当完了)", value: "22" },
  { label: "入荷(材料引当取消)", value: "23" },
  { label: "倉庫移動(出庫)", value: "33" },
  { label: "倉庫移動(入庫)", value: "34" },
  { label: "売上入力出荷", value: "41" },
  { label: "売上返品入庫", value: "42" },
  { label: "売上入力削除", value: "43" },
  { label: "売上返品削除", value: "44" },
  { label: "仕入入力入庫", value: "51" },
  { label: "仕入返品出荷", value: "52" },
  { label: "仕入入力削除", value: "53" },
  { label: "仕入返品削除", value: "54" },
  { label: "通常売上(移行)", value: "91" },
  { label: "見本売上(移行)", value: "92" },
  { label: "特売(移行)", value: "93" },
  { label: "通常売上返品(移行)  ", value: "94" },
  { label: "特売返品(移行)", value: "95" },
  { label: "通常仕入(移行)", value: "96" },
  { label: "通常仕入返品(移行)", value: "97" },
];

// B090051 受払区分
export const B090051UkeharaiKbn: SCode[] = [
  { label: "在庫調整(-)", value: "31" },
  { label: "在庫調整(+)", value: "32" },
  { label: "倉庫移動(出庫)", value: "33" },
  { label: "ロケーション移動(出庫)", value: "35" },
  { label: "ロケーション移動(入庫)", value: "36" },
];

// テーブル表示用 出荷状況
export const HyoziShukajokyo: SCode[] = [
  { label: "未処理", value: "0" },
  { label: "指示済", value: "1" },
  { label: "確定済", value: "2" },
  { label: "キャンセル", value: "9" },
];

// テーブル表示用 ピッキング発行状況
export const HyoziPickingjokyo: SCode[] = [
  { label: "未発行", value: "0" },
  { label: "未発行", value: "1" },
  { label: "発行済", value: "2" },
];

// 課税区分
export const KazeiKbn: SCode[] = [
  { label: "外税", value: "0" },
  { label: "内税", value: "1" },
  { label: "非課税", value: "2" },
  { label: "対象外", value: "3" },
];

//受注ワーク照会 取込データ種別
export const B010070EdiKbn: SCode[] = [
  { label: "ハンズEDI", value: "1" },
  { label: "ロフトEDI", value: "2" },
  { label: "汎用フォーマット", value: "3" },
];

//受注ワーク照会 受注ステータス(検索用)
export const B010070StatusKbn: SCode[] = [
  { label: "全て", value: "0" },
  { label: "未反映", value: "1" },
  { label: "受注反映済", value: "2" },
];

//受注ワーク照会 受注ステータス(テーブル表示用)
export const B010070JuchuHaneiKbn: SCode[] = [
  { label: "ファイル取込済", value: "0" },
  { label: "構成品不備", value: "1" },
  { label: "受注反映済", value: "2" },
  { label: "受注反映済(一部在庫不足)", value: "3" },
];

// 受注区分(テーブル表示用)
export const JuchuKbnView: SCode[] = [
  { label: "受注", value: "0" },
  { label: "見込", value: "1" },
];

//受注ワーク取込 取込データ種別
export const B010050TorikomidetaKbn: SCode[] = [
  { label: "東急ハンズEDI", value: "1" },
  { label: "ロフトEDI", value: "2" },
  { label: "汎用フォーマット", value: "3" },
];

//受注明細照会 受注ステータス(テーブル表示用)
export const B010030JuchuStatus: SCode[] = [
  { label: "未確定", value: "0" },
  { label: "確定済", value: "1" },
  { label: "確定済(出荷予定作成済)", value: "2" },
  { label: "確定済(出荷確定済)", value: "3" },
  { label: "キャンセル", value: "9" },
];

// B080020 作業指示書発行状況表示用
export const B080020SagyohakoView: SCode[] = [
  { label: "未発行", value: "0" },
  { label: "発行済", value: "1" },
];

// B020020 売上照会出力順
export const B020020SyuturyokuKbn: SCode[] = [
  { label: "売上日", value: "1" },
  { label: "得意先", value: "2" },
  { label: "売上No", value: "3" },
];

// B020020 テーブル表示用 伝票発行済区分
export const DenpyoHakoZumiKbn: SCode[] = [
  { label: "未発行", value: "0" },
  { label: "発行済", value: "1" },
];

// B080070出荷状況
export const b080070shukajokyou: SCode[] = [
  { label: "未処理", value: "0" },
  { label: "指示済", value: "1" },
  { label: "確定済", value: "2" },
  { label: "キャンセル", value: "9" },
];

// B020040 売上伝票発行済区分(発行区分)
export const UridenpyohakozumiKbn: SCode[] = [
  { label: "未発行", value: "0" },
  { label: "発行済み", value: "1" },
  { label: "納品書発行(入日記発行済分)", value: "2" },
];

// B070010 一覧表示選択
export const IchiranhyojiSelect: SCode[] = [
  { label: "入荷予定", value: "0" },
  { label: "入荷商品", value: "1" },
];

// 課税区分(受注・売上入力 テーブル表示用)
export const HyoziKazeiKbn: SCode[] = [
  { label: "課税", value: "0" },
  { label: "課税", value: "1" },
  { label: "非課税", value: "2" },
  { label: "対象外", value: "3" },
];

// 消化区分
export const B030060ShokaKbn: SCode[] = [
  { label: "通常", value: "0" },
  { label: "消化", value: "1" },
];

// B030080 売掛先条件
export const B030080Urikakejoken: SCode[] = [
  { label: "全件", value: "9" },
  { label: "月度内取引発生", value: "0" },
  { label: "前月残発生", value: "1" },
];

// B030080 出力順
export const B030080ShutsuryokuKbn: SCode[] = [
  { label: "伝票単位", value: "0" },
  { label: "明細単位", value: "1" },
];

// B020030 売上明細照会の営業所コード
export const UriageEigyoCd: SCode[] = [
  { label: "APJ", value: "1" },
  { label: "APJ工房", value: "2" },
];

// 発注内訳区分
export const HachuUchiwakeKbn: SCode[] = [
  { label: "通常", value: "0" },
  { label: "値引", value: "2" },
  { label: "見本", value: "3" },
  { label: "諸経費", value: "4" },
  { label: "送料", value: "5" },
];

// 発注関係の完了区分
export const HachuKanryoKbn: SCode[] = [
  { label: "未完了", value: "0" },
  { label: "全件", value: "1" },
];

// B040020 発注照会の出力順
export const B040020Shutsuryokujun: SCode[] = [
  { label: "発注日", value: "0" },
  { label: "入荷予定日", value: "1" },
  { label: "仕入先", value: "2" },
  { label: "発注No.", value: "3" },
];

// B040030 発注明細照会の出力順
export const B040030SyuturyokuKbn: SCode[] = [
  { label: "発注日", value: "0" },
  { label: "入荷予定日", value: "1" },
  { label: "商品", value: "2" },
  { label: "仕入先", value: "3" },
  { label: "倉庫", value: "4" },
  { label: "発注No.", value: "5" },
];

// 全件ありの商品種別
export const ZenkenShohinshubetsuKbn: SCode[] = [
  { label: "全件", value: "0" },
  { label: "通常商品", value: "1" },
  { label: "見込生産品", value: "3" },
  { label: "受注生産品", value: "4" },
  { label: "カレンダー", value: "5" },
  { label: "クリスマスカード", value: "6" },
  { label: "クリスマス雑貨", value: "7" },
  { label: "限定品", value: "8" },
  { label: "材料品", value: "9" },
];

// B040040 発注完了入力の出力順
export const B040040SyuturyokuKbn: SCode[] = [
  { label: "発注日", value: "0" },
  { label: "希望納期", value: "1" },
  { label: "仕入先", value: "2" },
  { label: "商品", value: "3" },
];

// B040040 発注完了入力の完了区分
export const B040040KanryoKbn: SCode[] = [
  { label: "未完了", value: "0" },
  { label: "完了", value: "1" },
  { label: "全件", value: "2" },
];

// B010010、B010060、B020010 受注生産品
export const JuchuSeisanhinKbn: SCode[] = [
  { label: "なし", value: "0" },
  { label: "あり", value: "1" },
];

// 入金内訳区分
export const NyukinUchiwakeKbn: SCode[] = [
  { label: "現金", value: "31" },
  { label: "小切手", value: "32" },
  { label: "手形", value: "33" },
  { label: "振込", value: "34" },
  { label: "相殺", value: "35" },
  { label: "手数料", value: "36" },
  { label: "値引", value: "37" },
  { label: "その他", value: "38" },
  { label: "調整", value: "39" },
  { label: "電手形", value: "40" },
];

// 手形種別コード
export const TegatashubetsuCdKbn: SCode[] = [
  { label: "約束手形(自己)", value: "0" },
  { label: "約束手形(廻り)", value: "1" },
  { label: "為替手形(自己)", value: "2" },
  { label: "為替手形(廻り)", value: "3" },
];

// B030070取引先区分
export const B030070TorihikisakiKbn: SCode[] = [
  { label: "得意先", value: "0" },
  { label: "請求先", value: "1" },
  { label: "売掛先", value: "2" },
];

// B030010 請求締処理 請求先個別区分
export const SeikyujokenKbn: SCode[] = [
  { label: "個別指定および範囲指定", value: "0" },
  { label: "全件", value: "9" },
];

// B030030 請求書タイプ
export const SeikyusyoType: SCode[] = [
  { label: "請求書", value: "1" },
  { label: "請求明細書", value: "2" },
];

// B030030 出力形式
export const OutputFormat: SCode[] = [
  { label: "印刷", value: "1" },
  { label: "PDF", value: "2" },
];

// B020040 伝票種別コード
export const DenpyoshubetsuCd: SCode[] = [
  { label: "APJ伝票", value: "0" },
  { label: "CS1型伝票", value: "1" },
  { label: "CS2型伝票", value: "2" },
  { label: "CSタイプ用伝票", value: "3" },
  { label: "家具統一伝票", value: "4" },
  { label: "百貨店統一伝票", value: "5" },
  { label: "真美堂伝票", value: "6" },
  { label: "サンリオ伝票", value: "7" },
  { label: "手書き伝票", value: "8" },
];

// B040010 発注入力の完了区分（テーブル表示用）
export const B040010KanryoKbn: SCode[] = [
  { label: "未完", value: "0" },
  { label: "完了", value: "1" },
];

// B070020 過不足理由
export const KafusokuRiyu: SCode[] = [
  { label: "未入荷", value: "01" },
  { label: "入荷数不足", value: "02" },
  { label: "破損", value: "03" },
  { label: "終売", value: "04" },
  { label: "他責破損", value: "05" },
  { label: "自責廃棄", value: "06" },
  { label: "キャンセル", value: "07" },
  { label: "伝票なし", value: "08" },
  { label: "入荷過多", value: "09" },
  { label: "その他", value: "99" },
];

// 削除予定区分
export const SakujoyoteiKbn: SCode[] = [
  { label: "通常", value: "0" },
  { label: "削除", value: "1" },
];

// B100050 モード
export const B100050Mode: SCode[] = [
  { label: "新規", value: "0" },
  { label: "修正", value: "1" },
];

// B100060 モード
export const B100060Mode: SCode[] = [
  { label: "新規", value: "0" },
  { label: "修正", value: "1" },
];

// 性別区分
export const SeibetsuKbn: SCode[] = [
  { label: "男性", value: "0" },
  { label: "女性", value: "1" },
  { label: "その他", value: "2" },
];

// B100110 モード
export const B100110Mode: SCode[] = [
  { label: "新規", value: "0" },
  { label: "修正", value: "1" },
];

// B100110 単価区分
export const TankaKbn: SCode[] = [
  { label: "通常", value: "0" },
  { label: "WH単価", value: "1" },
];

// B100110 セット商品
export const SetshohinKbn: SCode[] = [
  { label: "単品", value: "0" },
  { label: "セット品", value: "1" },
];

// B100110 売切区分
export const UrikiriKbn: SCode[] = [
  { label: "通常品", value: "0" },
  { label: "売切品", value: "1" },
];

// B100110 在庫管理
export const ZaikokanriKbn: SCode[] = [
  { label: "管理しない", value: "0" },
  { label: "管理する", value: "1" },
];

// B100110 在庫引当
export const ZaikohikiateKbn: SCode[] = [
  { label: "引当しない", value: "0" },
  { label: "引当する", value: "1" },
];

// B100110 マイナス在庫
export const MinuszaikocheckKbn: SCode[] = [
  { label: "チェックしない", value: "0" },
  { label: "チェックする", value: "1" },
];

// B100060 消化区分
export const B100ShokaKbn: SCode[] = [
  { label: "標準", value: "0" },
  { label: "消化", value: "1" },
];

// B100060 得意先区分
export const TokuiKbn: SCode[] = [
  { label: "ならない", value: "0" },
  { label: "なる", value: "1" },
];

// B100060 請求先区分
export const SeikyuKbn: SCode[] = [
  { label: "ならない", value: "0" },
  { label: "なる", value: "1" },
];

// B100060 売掛先区分
export const UrikakeKbn: SCode[] = [
  { label: "ならない", value: "0" },
  { label: "なる", value: "1" },
];

// B100060 納入先区分
export const NonyuKbn: SCode[] = [
  { label: "ならない", value: "0" },
  { label: "なる", value: "1" },
];

// B100060 回収月
export const KaishuyoteiM: SCode[] = [
  { label: "当月", value: "0" },
  { label: "翌月", value: "1" },
  { label: "翌々月", value: "2" },
  { label: "3ヶ月先", value: "3" },
  { label: "4ヶ月先", value: "4" },
  { label: "5ヶ月先", value: "5" },
  { label: "6ヶ月先", value: "6" },
  { label: "7ヶ月先", value: "7" },
  { label: "8ヶ月先", value: "8" },
  { label: "9ヶ月先", value: "9" },
];

// B100060 回収条件
export const KaishuKbn: SCode[] = [
  { label: "現金", value: "31" },
  { label: "小切手", value: "32" },
  { label: "手形", value: "33" },
  { label: "振込", value: "34" },
  { label: "相殺", value: "35" },
  { label: "手数料", value: "36" },
  { label: "値引", value: "37" },
  { label: "その他", value: "38" },
  { label: "調整", value: "39" },
  { label: "電手形", value: "40" },
];

// B100060 請求書発行
export const SeikyushoKbn: SCode[] = [
  { label: "発行しない", value: "0" },
  { label: "発行する", value: "1" },
];

// B100060 請求書形式
export const SeikyushokeishikiKbn: SCode[] = [
  { label: "合計請求書", value: "0" },
  { label: "請求明細書", value: "1" },
];

// B100060 請求書番号採番
export const SeikyushosaibanKbn: SCode[] = [
  { label: "採番しない", value: "0" },
  { label: "請求先毎", value: "1" },
];

// B100060 出力商品コード
export const ShutsuryokushohinCd: SCode[] = [
  { label: "商品CD", value: "0" },
  { label: "JAN", value: "1" },
  { label: "相手CD", value: "2" },
];

// B100060 金額丸め
export const KinmaremeKbn: SCode[] = [
  { label: "四捨五入", value: "0" },
  { label: "切り捨て", value: "1" },
  { label: "切り上げ", value: "2" },
];

// B100060 消費税丸め
export const ZeimarumeKbn: SCode[] = [
  { label: "四捨五入", value: "0" },
  { label: "切り捨て", value: "1" },
  { label: "切り上げ", value: "2" },
];

// B100060 単価丸め
export const TankamarumeKbn: SCode[] = [
  { label: "四捨五入", value: "0" },
  { label: "切り捨て", value: "1" },
  { label: "切り上げ", value: "2" },
];

// B100060 単価端数位置
export const Tankahasuichi: SCode[] = [
  { label: "整数部", value: "0" },
  { label: "小数部", value: "1" },
];

// B100060 上代表示区分
export const JodaihyojiKbn: SCode[] = [
  { label: "通常", value: "0" },
  { label: "内税", value: "1" },
];

// B100060 単価端数位置
export const B100060Tankahasuichi: SCode[] = [
  { label: "小数部", value: "0" },
  { label: "整数部", value: "1" },
];

// B100060 専用伝票No.区分
export const KyakusakinoKbn: SCode[] = [
  { label: "しない", value: "0" },
  { label: "する", value: "1" },
];

// B040040 完了区分 テーブル表示用
export const B040040KanryoKbnTable: SCode[] = [
  { label: "", value: "0" },
  { label: "完了", value: "1" },
];

// B050030 仕入明細照会 出力順
export const B050030SyuturyokuKbn: SCode[] = [
  { label: "仕入日", value: "0" },
  { label: "商品", value: "1" },
  { label: "仕入先", value: "2" },
];

// B100070 標準納入先区分
export const HyojunnonyuKbn: SCode[] = [
  { label: "非標準", value: "0" },
  { label: "標準", value: "1" },
];

// B100070 標準納入先区分(グリッド表示用)
export const B100070HyojunnonyuKbn: SCode[] = [
  { label: "", value: "0" },
  { label: "標準", value: "1" },
];

// B000201 採番件数
export const Saibankensu: SCode[] = [
  { label: "1件", value: "1" },
  { label: "2件", value: "2" },
  { label: "3件", value: "3" },
  { label: "4件", value: "4" },
  { label: "5件", value: "5" },
  { label: "6件", value: "6" },
  { label: "7件", value: "7" },
  { label: "8件", value: "8" },
  { label: "9件", value: "9" },
  { label: "10件", value: "10" },
];

// B110010 締区分
export const GetsujiYoyakuKbn: SCode[] = [
  { label: "仮締め", value: "0" },
  { label: "本締め", value: "1" },
];

// B100120 商品分類
export const B100120ShohinbunruiKbn: SCode[] = [
  { label: "大分類", value: "0" },
  { label: "中分類", value: "1" },
  { label: "小分類", value: "2" },
];

// B100120 モード
export const B100120Mode: SCode[] = [
  { label: "新規", value: "0" },
  { label: "修正", value: "1" },
  { label: "削除", value: "2" },
];

// B100190 入庫ロケ区分
export const NyukolocationKbn: SCode[] = [
  { label: "入庫ロケでない", value: "0" },
  { label: "入庫ロケである", value: "1" },
];

// B100190 出庫ロケ区分
export const ShukolocationKbn: SCode[] = [
  { label: "出庫ロケでない", value: "0" },
  { label: "出庫ロケである", value: "1" },
];

// B100230 モード
export const Mode: SCode[] = [
  { label: "新規", value: "0" },
  { label: "修正", value: "1" },
  { label: "削除", value: "2" },
];

// B100140 単価区分
export const B100140TankaKbn: SCode[] = [
  { label: "通常売上", value: "0" },
  { label: "仕入", value: "2" },
];

// B100143 単価区分
export const B100143TankaKbn: SCode[] = [
  { label: "通常売上", value: "0" },
  { label: "仕入", value: "2" },
  { label: "全件", value: "9" },
];

// B100080 モード
export const B100080Mode: SCode[] = [
  { label: "新規", value: "0" },
  { label: "修正", value: "1" },
];

// B100080 仕入先区分
export const ShireKbn: SCode[] = [
  { label: "ならない", value: "0" },
  { label: "なる", value: "1" },
];

// B100080 支払先区分
export const ShiharaiKbn: SCode[] = [
  { label: "ならない", value: "0" },
  { label: "なる", value: "1" },
];

// B100080 発注書発行
export const HachuHako: SCode[] = [
  { label: "非発行", value: "0" },
  { label: "即時発行", value: "1" },
  { label: "一括発行", value: "2" },
];

// B100080 発注書形式
export const HachuKeishiki: SCode[] = [{ label: "自社", value: "0" }];

// B100080 単価設定
export const TankaSetei: SCode[] = [
  { label: "標準単価", value: "0" },
  { label: "取引先別単価", value: "1" },
  { label: "前回納入単価", value: "2" },
  { label: "取引先分類別単価", value: "3" },
  { label: "倉庫別単価", value: "4" },
  { label: "取引先別商品分類別単価", value: "5" },
  { label: "取引先分類別商品分類別単価", value: "6" },
];

// B100180 WH 単価区分
export const B100180WhTankaKbn: SCode[] = [
  { label: "WH単価", value: "0" },
  { label: "WH原単価", value: "1" },
];

// B100183 WH 単価区分
export const WhTankaKbn: SCode[] = [
  { label: "WH単価", value: "0" },
  { label: "WH原単価", value: "1" },
  { label: "全件", value: "2" },
];

// B100200 フロア
export const Floor: SCode[] = [
  { label: "1F", value: "1" },
  { label: "2F", value: "2" },
  { label: "3F", value: "3" },
  { label: "4F", value: "4" },
  { label: "他5", value: "5" },
  { label: "他6", value: "6" },
  { label: "他7", value: "7" },
  { label: "他8", value: "8" },
  { label: "他9", value: "9" },
  { label: "他A", value: "A" },
  { label: "他B", value: "B" },
  { label: "他C", value: "C" },
  { label: "他D", value: "D" },
  { label: "他E", value: "E" },
  { label: "他F", value: "F" },
  { label: "他G", value: "G" },
  { label: "他H", value: "H" },
  { label: "他I", value: "I" },
  { label: "他J", value: "J" },
  { label: "他K", value: "K" },
  { label: "他L", value: "L" },
  { label: "他M", value: "M" },
  { label: "仮置き", value: "N" },
  { label: "未検品", value: "W" },
  { label: "返却品", value: "Z" },
];

// B100210 ピッキング方式
export const PickingMethod: SCode[] = [
  { label: "オーダーピッキング", value: "1" },
  { label: "トータルピッキング", value: "2" },
];

// B100040 モード
export const B100040Mode: SCode[] = [
  { label: "新規", value: "0" },
  { label: "修正", value: "1" },
];

// B100090 モード
export const B100090Mode: SCode[] = [
  { label: "新規", value: "0" },
  { label: "修正", value: "1" },
];

// B100100 モード
export const B100100Mode: SCode[] = [
  { label: "新規", value: "0" },
  { label: "修正", value: "1" },
];

// B100100 モード
export const B100180Mode: SCode[] = [
  { label: "新規", value: "0" },
  { label: "修正", value: "1" },
  { label: "削除", value: "2" },
];

// B100100 倉庫マスタメンテの倉庫種別
export const B100100Sokoshubetsu: SCode[] = [
  { label: "物理倉庫", value: "0" },
  { label: "論理倉庫", value: "1" },
  { label: "引当倉庫", value: "2" },
  { label: "材料倉庫", value: "3" },
  { label: "返品倉庫", value: "4" },
  { label: "その他倉庫", value: "5" },
];

// B100100 ロケーション管理区分
export const LocationKanriKbn: SCode[] = [
  { label: "管理しない", value: "0" },
  { label: "管理する", value: "1" },
];

// B010040 ステータス
export const B010040Status: SCode[] = [
  { label: "全件", value: "1" },
  { label: "出荷済", value: "2" },
  { label: "未出荷", value: "3" },
];

// B110020 消化区分
export const B110020ShokaKbn: SCode[] = [
  { label: "全件", value: "9" },
  { label: "通常", value: "0" },
  { label: "消化", value: "1" },
];
// B110030 出力形式
export const B110030OutputType: SCode[] = [
  { label: "標準出力", value: "0" },
  { label: "季節品出力", value: "1" },
];

// B110030 消化区分
export const B110030ShokaKbn: SCode[] = [
  { label: "全件", value: "9" },
  { label: "通常", value: "0" },
  { label: "消化", value: "1" },
];

// B050020 仕入照会 出力順
export const B050020SyuturyokuKbn: SCode[] = [
  { label: "仕入日", value: "0" },
  { label: "仕入先", value: "1" },
];

// 仕入内訳区分
export const ShireUchiwakeKbn: SCode[] = [
  { label: "通常", value: "0" },
  { label: "通常返", value: "10" },
];

// B050010 仕入入力の完了区分
export const B050010KanryoKbn: SCode[] = [
  { label: "未完", value: "0" },
  { label: "完了", value: "1" },
];

// B080090 取込先
export const Torikomisaki: SCode[] = [
  { label: "西濃運輸 カンガルーマジック2", value: "1" },
  { label: "ヤマト運輸 B2クラウド", value: "2" },
  { label: "佐川急便 e飛伝3", value: "3" },
];
